export default function genererSprint() {
  return {
    titre: '',
    sprint: '',
    dateAffichage: null,
    dateRetraitHomePage: null,
  };
}
